import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromRouter from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('router', fromRouter.routerReducer),
  ],
})
export class RouteStoreModule {}
